import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKFloatToRESTFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixFastgalleryItemV1ItemServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'editor._base_domain_': [
      {
        srcPath: '/_api/item',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/item',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/item',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/item',
        destPath: '',
      },
      {
        srcPath: '/fastgallery/item/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
      {
        srcPath: '/fastgallery/item/v1/items',
        destPath: '/v1/items',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/item',
        destPath: '',
      },
      {
        srcPath: '/fastgallery/item/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
      {
        srcPath: '/fastgallery/item/v1/items',
        destPath: '/v1/items',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/fastgallery/item/v1/items',
        destPath: '/v1/items',
      },
      {
        srcPath: '/fastgallery/item/v1/bulk/items',
        destPath: '/v1/bulk/items',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_fast-gallery_items';

/** create item (todo: tech writer to add more details) */
export function createItem(payload: object): RequestOptionsFactory<any> {
  function __createItem({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'item.sortOrder' },
          { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
          { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
          { path: 'item.media.imageOptions.focalPoint.x' },
          { path: 'item.media.imageOptions.focalPoint.y' },
          { path: 'item.media.imageOptions.unsharpMasking.amount' },
          { path: 'item.media.imageOptions.unsharpMasking.radius' },
          { path: 'item.media.imageOptions.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'item.createdDate' },
          { path: 'item.updatedDate' },
          { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'POST' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.CreateItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'item.media.imageOptions.focalPoint.x' },
              { path: 'item.media.imageOptions.focalPoint.y' },
              { path: 'item.media.imageOptions.unsharpMasking.amount' },
              { path: 'item.media.imageOptions.unsharpMasking.radius' },
              { path: 'item.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createItem;
}

/** Retrieves a Item. */
export function getItem(payload: object): RequestOptionsFactory<any> {
  function __getItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'GET' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.GetItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'item.media.imageOptions.focalPoint.x' },
              { path: 'item.media.imageOptions.focalPoint.y' },
              { path: 'item.media.imageOptions.unsharpMasking.amount' },
              { path: 'item.media.imageOptions.unsharpMasking.radius' },
              { path: 'item.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getItem;
}

/**
 * Updates a Item.
 *
 * Each time the Item is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the Item.
 * This ensures you're working with the latest Item
 * and prevents unintended overwrites.
 */
export function updateItem(payload: object): RequestOptionsFactory<any> {
  function __updateItem({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'fieldMask' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'item.sortOrder' },
          { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
          { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
          { path: 'item.media.imageOptions.focalPoint.x' },
          { path: 'item.media.imageOptions.focalPoint.y' },
          { path: 'item.media.imageOptions.unsharpMasking.amount' },
          { path: 'item.media.imageOptions.unsharpMasking.radius' },
          { path: 'item.media.imageOptions.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'item.createdDate' },
          { path: 'item.updatedDate' },
          { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'PATCH' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.UpdateItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/{item.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'item.media.imageOptions.focalPoint.x' },
              { path: 'item.media.imageOptions.focalPoint.y' },
              { path: 'item.media.imageOptions.unsharpMasking.amount' },
              { path: 'item.media.imageOptions.unsharpMasking.radius' },
              { path: 'item.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateItem;
}

/** delete item (todo: tech writer to add more details) */
export function deleteItem(payload: object): RequestOptionsFactory<any> {
  function __deleteItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'DELETE' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.DeleteItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteItem;
}

/**
 * Creates a query to retrieve a list of gallery items.
 *
 * The `queryItems()` method builds a query to retrieve a list of gallery items and returns an `ItemsQueryBuilder` object.
 *
 * The returned object contains the query definition, which is used to run the query using the `find()` method.
 *
 * You can refine the query by chaining `ItemsQueryBuilder` methods onto the query. `ItemsQueryBuilder` methods enable you to filter, sort, and control the results that `queryItems()` returns.
 */
export function queryItems(payload: object): RequestOptionsFactory<any> {
  function __queryItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'GET' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.QueryItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/query',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload, true),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'items.sortOrder' },
              { path: 'items.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'items.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'items.media.imageOptions.focalPoint.x' },
              { path: 'items.media.imageOptions.focalPoint.y' },
              { path: 'items.media.imageOptions.unsharpMasking.amount' },
              { path: 'items.media.imageOptions.unsharpMasking.radius' },
              { path: 'items.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'items.createdDate' },
              { path: 'items.updatedDate' },
              { path: 'items.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
      fallback: [
        {
          method: 'POST' as any,
          url: resolveWixFastgalleryItemV1ItemServiceUrl({
            protoPath: '/v1/items/query',
            data: payload,
            host,
          }),
          data: payload,
        },
      ],
    };

    return metadata;
  }

  return __queryItems;
}

/** Updates extended fields of a Item without incrementing revision */
export function updateExtendedFields(
  payload: object
): RequestOptionsFactory<any> {
  function __updateExtendedFields({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'POST' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.UpdateExtendedFields',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/{id}/update-extended-fields',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'item.media.imageOptions.focalPoint.x' },
              { path: 'item.media.imageOptions.focalPoint.y' },
              { path: 'item.media.imageOptions.unsharpMasking.amount' },
              { path: 'item.media.imageOptions.unsharpMasking.radius' },
              { path: 'item.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateExtendedFields;
}

/** Create multiple Items in a single request. Works synchronously. */
export function bulkCreateItems(payload: object): RequestOptionsFactory<any> {
  function __bulkCreateItems({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'items.sortOrder' },
          { path: 'items.media.imageOptions.imageInfo.focalPoint.x' },
          { path: 'items.media.imageOptions.imageInfo.focalPoint.y' },
          { path: 'items.media.imageOptions.focalPoint.x' },
          { path: 'items.media.imageOptions.focalPoint.y' },
          { path: 'items.media.imageOptions.unsharpMasking.amount' },
          { path: 'items.media.imageOptions.unsharpMasking.radius' },
          { path: 'items.media.imageOptions.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'items.createdDate' },
          { path: 'items.updatedDate' },
          { path: 'items.media.imageOptions.imageInfo.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'POST' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.BulkCreateItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/bulk/items/create',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'results.item.sortOrder' },
              {
                path: 'results.item.media.imageOptions.imageInfo.focalPoint.x',
              },
              {
                path: 'results.item.media.imageOptions.imageInfo.focalPoint.y',
              },
              { path: 'results.item.media.imageOptions.focalPoint.x' },
              { path: 'results.item.media.imageOptions.focalPoint.y' },
              { path: 'results.item.media.imageOptions.unsharpMasking.amount' },
              { path: 'results.item.media.imageOptions.unsharpMasking.radius' },
              {
                path: 'results.item.media.imageOptions.unsharpMasking.threshold',
              },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              {
                path: 'results.item.media.imageOptions.imageInfo.urlExpirationDate',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkCreateItems;
}

/** Update multiple Items in a single request. Works synchronously. */
export function bulkUpdateItems(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateItems({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'items.fieldMask' }],
      },
      {
        transformFn: transformSDKFloatToRESTFloat,
        paths: [
          { path: 'items.item.sortOrder' },
          { path: 'items.item.media.imageOptions.imageInfo.focalPoint.x' },
          { path: 'items.item.media.imageOptions.imageInfo.focalPoint.y' },
          { path: 'items.item.media.imageOptions.focalPoint.x' },
          { path: 'items.item.media.imageOptions.focalPoint.y' },
          { path: 'items.item.media.imageOptions.unsharpMasking.amount' },
          { path: 'items.item.media.imageOptions.unsharpMasking.radius' },
          { path: 'items.item.media.imageOptions.unsharpMasking.threshold' },
        ],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'items.item.createdDate' },
          { path: 'items.item.updatedDate' },
          { path: 'items.item.media.imageOptions.imageInfo.urlExpirationDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'POST' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.BulkUpdateItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/bulk/items/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'results.item.sortOrder' },
              {
                path: 'results.item.media.imageOptions.imageInfo.focalPoint.x',
              },
              {
                path: 'results.item.media.imageOptions.imageInfo.focalPoint.y',
              },
              { path: 'results.item.media.imageOptions.focalPoint.x' },
              { path: 'results.item.media.imageOptions.focalPoint.y' },
              { path: 'results.item.media.imageOptions.unsharpMasking.amount' },
              { path: 'results.item.media.imageOptions.unsharpMasking.radius' },
              {
                path: 'results.item.media.imageOptions.unsharpMasking.threshold',
              },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.item.createdDate' },
              { path: 'results.item.updatedDate' },
              {
                path: 'results.item.media.imageOptions.imageInfo.urlExpirationDate',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateItems;
}

/** Delete multiple Items in a single request. Works synchronously. */
export function bulkDeleteItems(payload: object): RequestOptionsFactory<any> {
  function __bulkDeleteItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'POST' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.BulkDeleteItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/bulk/items/delete',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __bulkDeleteItems;
}

/** Removes deleted Item from TrashBin */
export function removeItemFromTrashBin(
  payload: object
): RequestOptionsFactory<any> {
  function __removeItemFromTrashBin({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'DELETE' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.RemoveItemFromTrashBin',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/trash-bin/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __removeItemFromTrashBin;
}

/** Restores an Item from TrashBin */
export function restoreItemFromTrashBin(
  payload: object
): RequestOptionsFactory<any> {
  function __restoreItemFromTrashBin({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'POST' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.RestoreItemFromTrashBin',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/trash-bin/{itemId}/restore',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'item.media.imageOptions.focalPoint.x' },
              { path: 'item.media.imageOptions.focalPoint.y' },
              { path: 'item.media.imageOptions.unsharpMasking.amount' },
              { path: 'item.media.imageOptions.unsharpMasking.radius' },
              { path: 'item.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __restoreItemFromTrashBin;
}

/** Get deleted Item from TrashBin */
export function getDeletedItem(payload: object): RequestOptionsFactory<any> {
  function __getDeletedItem({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'GET' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.GetDeletedItem',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/trash-bin/{itemId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'item.sortOrder' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'item.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'item.media.imageOptions.focalPoint.x' },
              { path: 'item.media.imageOptions.focalPoint.y' },
              { path: 'item.media.imageOptions.unsharpMasking.amount' },
              { path: 'item.media.imageOptions.unsharpMasking.radius' },
              { path: 'item.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'item.createdDate' },
              { path: 'item.updatedDate' },
              { path: 'item.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getDeletedItem;
}

/** List deleted Items which are in TrashBin */
export function listDeletedItems(payload: object): RequestOptionsFactory<any> {
  function __listDeletedItems({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.fastgallery.item.v1.item',
      method: 'GET' as any,
      methodFqn: 'wix.fastgallery.item.v1.ItemService.ListDeletedItems',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFastgalleryItemV1ItemServiceUrl({
        protoPath: '/v1/items/trash-bin',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload, true),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              { path: 'items.sortOrder' },
              { path: 'items.media.imageOptions.imageInfo.focalPoint.x' },
              { path: 'items.media.imageOptions.imageInfo.focalPoint.y' },
              { path: 'items.media.imageOptions.focalPoint.x' },
              { path: 'items.media.imageOptions.focalPoint.y' },
              { path: 'items.media.imageOptions.unsharpMasking.amount' },
              { path: 'items.media.imageOptions.unsharpMasking.radius' },
              { path: 'items.media.imageOptions.unsharpMasking.threshold' },
            ],
          },
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'items.createdDate' },
              { path: 'items.updatedDate' },
              { path: 'items.media.imageOptions.imageInfo.urlExpirationDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listDeletedItems;
}
